import { render, staticRenderFns } from "./AccidentCommBase.vue?vue&type=template&id=55cde4d2&scoped=true"
import script from "./AccidentCommBase.vue?vue&type=script&lang=js"
export * from "./AccidentCommBase.vue?vue&type=script&lang=js"
import style0 from "./AccidentCommBase.vue?vue&type=style&index=0&id=55cde4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cde4d2",
  null
  
)

export default component.exports